export default "__VITE_ASSET__DjM54xVa__"